import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';
import { Keys } from '@oracle/oraclejet-testing/UNSAFE_Driver';
import { byCss } from '@oracle/oraclejet-testing/UNSAFE_Locators';

export class TextAreaAutosizeAdapter extends TestAdapter {
  /**
   * Clear and commit the value of the textarea element
   * @returns Promise<void>
   */
  async clear() {
    await this.changeValue(undefined);
  }

  /**
   * Change and commit the value of the textarea element
   * @param value {string | undefined} The new value
   * @returns Promise<void>
   */
  async changeValue(value: string | undefined) {
    const driver = this.getTestDriver();
    const el = await this.getElement();

    // Find the <textarea> element underneath the root.
    const textarea = await el.waitForElement(byCss('textarea'));

    // Clear any existing value.
    await driver.sendKeys(textarea, Keys['CONTROL_COMMAND'], 'a');
    await driver.sendKeys(textarea, Keys['DELETE']);

    // Type the value into <textarea>.
    if (value !== undefined) {
      await driver.sendKeys(textarea, value);
    }

    // Commit.
    await driver.sendKeys(textarea, Keys['TAB']);
  }
}
